var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgCircuitBreaker = function SvgCircuitBreaker(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CB366D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.918 12.6a1 1 0 0 0-.873-.6h-4.599l1.275-4.74A.996.996 0 0 0 19.758 6H12.73a1.007 1.007 0 0 0-1.004.74l-2.69 9.998a.996.996 0 0 0 .973 1.26h3.886l-1.818 6.739a.995.995 0 0 0 .49 1.142 1.007 1.007 0 0 0 1.227-.212l10.943-11.998a.999.999 0 0 0 .181-1.07Zm-9.829 8.678 1.074-4a.996.996 0 0 0-.963-1.26h-3.855L13.492 8h4.95l-1.276 4.74a.996.996 0 0 0 .549 1.168c.142.065.299.097.455.091h3.585l-6.667 7.279Z",
    fill: "#fff"
  })));
};
export default SvgCircuitBreaker;